// extracted by mini-css-extract-plugin
export default {"root":"I41EiF","bg":"h4y3L1"};